<template>
  <div>
    <v-navigation-drawer
      v-model="localDrawer"
      absolute
      right
      temporary
      width="400"
      class="glass-drawer"
      dark
      style="display: flex; flex-direction: column">
      <div class="d-flex align-center justify-space-between px-6 py-5 drawer-header">
        <span class="text-h5 font-weight-black white--text">Warenkorb</span>
        <v-btn icon color="white" class="premium-btn-icon-circle" small @click="localDrawer = false">
          <v-icon size="18">mdi-close</v-icon>
        </v-btn>
      </div>

      <div v-if="!cartProducts.length" class="d-flex flex-column align-center justify-center flex-grow-1 px-6 py-12">
        <v-icon size="64" color="grey lighten-1" class="mb-4">mdi-cart-outline</v-icon>
        <span class="text-subtitle-1 grey--text text--lighten-1 font-weight-medium text-center">Dein Warenkorb ist noch leer.</span>
        <v-btn text color="#00B074" class="mt-2 font-weight-bold" @click="localDrawer = false">Produkte ansehen</v-btn>
      </div>

      <v-list dense class="px-4 py-4 flex-grow-1 overflow-y-auto cart-list-items" v-else>
        <div
          v-for="(product, index) in cartProducts"
          :key="product.title + index"
          class="mb-4 pa-4 rounded-xl d-flex flex-column cart-item-container"
          @click="openProduct(product._id)">
          <div class="d-flex justify-space-between align-start">
            <div style="max-width: 70%">
              <h4 class="text-subtitle-1 font-weight-bold cart-item-title mb-1 text-truncate" style="max-width: 220px">
                {{ product.title }}
              </h4>
              <p class="text-caption cart-item-desc mb-2 text-truncate" style="max-width: 220px">
                {{ product.shortDescription }}
              </p>
            </div>

            <div class="d-flex align-center rounded-pill pa-1 qty-control" @click.stop>
              <v-btn icon x-small color="white" @click="removeProduct(product)">
                <v-icon size="14" color="white">mdi-minus</v-icon>
              </v-btn>
              <span class="white--text font-weight-bold px-2 qty-text">{{ product.amount }}</span>
              <v-btn icon x-small color="white" @click="addProduct(product)">
                <v-icon size="14" color="white">mdi-plus</v-icon>
              </v-btn>
            </div>
          </div>

          <v-divider class="my-2" style="background-color: rgba(255, 255, 255, 0.05)"></v-divider>

          <div class="d-flex justify-space-between align-center">
            <span class="text-caption cart-item-desc">{{ product.amount }}x à {{ product.price }} CHF</span>
            <span class="font-weight-black cart-item-price">{{ product.amount * product.price }} CHF</span>
          </div>
        </div>
      </v-list>

      <div class="pa-6 mt-auto drawer-footer" v-if="cartProducts.length">
        <div class="d-flex justify-space-between align-center mb-5">
          <span class="text-subtitle-1 grey--text text--lighten-1 font-weight-medium">Gesamtsumme</span>
          <span class="text-h5 font-weight-black cart-item-price">{{ cartTotalPrice }} CHF</span>
        </div>

        <v-btn @click="proceedToCheckout()" class="premium-btn py-7 text-subtitle-1" block>
          <v-icon left>mdi-credit-card-outline</v-icon>
          Personalisieren & Kasse
        </v-btn>
      </div>
    </v-navigation-drawer>

    <v-dialog v-model="noUserFoundDialog" max-width="500" overlay-color="#050608" overlay-opacity="0.9">
      <v-card class="glass-card pa-6" dark style="background-color: #1e1e1e !important">
        <v-card-title
          class="text-h5 font-weight-bold white--text justify-center text-center pb-2 pt-0"
          style="word-break: keep-all; line-height: 1.3">
          Anmeldung erforderlich
        </v-card-title>

        <v-card-text class="grey--text text--lighten-1 text-center px-0 pb-6 pt-2" style="font-size: 1rem; line-height: 1.5">
          Melde dich mit deinem Roody-Account an oder erstelle einen neuen Account, um mit der Bestellung fortzufahren.
        </v-card-text>

        <v-card-actions class="d-flex flex-column px-0 py-0 gap-3">
          <v-btn class="premium-btn py-6 mb-3" block @click="showLoginDialog = true"> Anmelden </v-btn>
          <v-btn class="premium-btn-outline py-6" block text @click="showRegisterDialog = true"> Neuen Account erstellen </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <register
      @register="newAccountRegistered"
      :auto-login="false"
      requirePassword
      @close="showRegisterDialog = false"
      :active="showRegisterDialog"></register>
    <login @login="accountLogin" :auto-login="false" @close="showLoginDialog = false" :active="showLoginDialog"></login>
  </div>
</template>

<script>
import api from "../../api"
import { mapGetters, mapActions, mapState } from "vuex"
import register from "../launchScreen/register.vue"
import login from "../launchScreen/login.vue"

export default {
  components: {
    register: register,
    login: login,
  },
  data() {
    return {
      noUserFoundDialog: false,
      showLoginDialog: false,
      showRegisterDialog: false,
      // HIER: Das lokale "drawer: false" wurde gelöscht!
      products: [],
      user: null,
    }
  },
  async created() {
    this.fetchCustomer()
  },
  computed: {
    ...mapState("shopStore", ["cartVisibilityToggle", "cartProducts"]),
    ...mapGetters("shopStore", ["cartTotalPrice"]),

    // NEU: Diese Computed Property ersetzt den Watcher komplett
    localDrawer: {
      get() {
        return this.cartVisibilityToggle
      },
      set(value) {
        // Wenn Vuetify den Drawer schließt (value === false), der Store aber noch true ist,
        // feuern wir die Action ab, um den Store wieder synchron auf false zu toggeln.
        if (value === false && this.cartVisibilityToggle === true) {
          this.toggleCartVisiblity()
        }
      },
    },
  },
  methods: {
    // HIER: 'toggleCartVisiblity' zu den Actions hinzugefügt
    ...mapActions("shopStore", ["addProductToCart", "removeProductFromCart", "openProductFromStore", "toggleCartVisiblity"]),

    async fetchCustomer() {
      let customer = await api.getUser()
      this.user = customer.user
    },
    proceedToCheckout() {
      if (!this.user) {
        return (this.noUserFoundDialog = true)
      }
      if (this.cartProducts.length) {
        this.$router.push("/shop/checkout")
      } else {
        this.$toast.error("Füge mindestens ein Produkt zum Warenkorb hinzu.")
      }
    },
    addProduct(product) {
      this.addProductToCart(product)
    },
    removeProduct(product) {
      this.removeProductFromCart(product)
    },
    openProduct(id) {
      console.log("opening")
      this.openProductFromStore(id)
    },
    async newAccountRegistered(data) {
      localStorage.setItem("token", data.token)
      localStorage.setItem("user", JSON.stringify(data.user))
      this.showRegisterDialog = false

      api.getUserRights().then((r) => {
        localStorage.setItem("userRights", JSON.stringify({ userRights: r }))
        this.setUserRights(JSON.parse(JSON.stringify(r)))
      })
      this.fetchCustomer()
      this.noUserFoundDialog = false
      this.$toast.success("Neuer Account wurde erfolgreich erstellt.")
    },
    async accountLogin(login) {
      localStorage.setItem("token", login.token)
      localStorage.setItem("user", JSON.stringify(login.user))

      api.getUserRights().then((r) => {
        localStorage.setItem("userRights", JSON.stringify({ userRights: r }))
        this.setUserRights(JSON.parse(JSON.stringify(r)))
      })
      this.showLoginDialog = false
      this.noUserFoundDialog = false
      this.$toast.success("Erfolgreich eingeloggt.")
      this.fetchCustomer()
    },
  },
  // HIER: Der gesamte "watch"-Block wurde gelöscht!
}
</script>

<style>
@import "./shopCommon.css";

/* Force Shopping Cart Drawer Dark colors and styles */
.v-navigation-drawer.glass-drawer {
  background: radial-gradient(circle at bottom left, #102019, #08090c 80%) !important;
  color: #ffffff !important;
  border-left: 1px solid rgba(255, 255, 255, 0.08) !important;
}

.v-navigation-drawer.glass-drawer .v-navigation-drawer__content {
  background-color: transparent !important;
  display: flex;
  flex-direction: column;
}

.v-navigation-drawer.glass-drawer .drawer-header {
  border-bottom: 1px solid rgba(255, 255, 255, 0.08) !important;
}

.v-navigation-drawer.glass-drawer .cart-list-items {
  background: transparent !important;
}

/* Force Cart Items to be dark card style */
.v-navigation-drawer.glass-drawer .cart-item-container {
  background: rgba(255, 255, 255, 0.02) !important;
  border: 1px solid rgba(255, 255, 255, 0.05) !important;
  transition: all 0.3s ease;
  cursor: pointer;
}

.v-navigation-drawer.glass-drawer .cart-item-container:hover {
  background: rgba(255, 255, 255, 0.04) !important;
  border-color: rgba(0, 176, 116, 0.3) !important;
}

.v-navigation-drawer.glass-drawer .cart-item-title {
  color: #ffffff !important;
}

.v-navigation-drawer.glass-drawer .cart-item-desc {
  color: #94a3b8 !important;
}

.v-navigation-drawer.glass-drawer .cart-item-price {
  color: #00b074 !important;
}

/* Quantity controls styles */
.v-navigation-drawer.glass-drawer .qty-control {
  background: rgba(255, 255, 255, 0.03) !important;
  border: 1px solid rgba(255, 255, 255, 0.08) !important;
}

.v-navigation-drawer.glass-drawer .qty-text {
  color: #ffffff !important;
}

.v-navigation-drawer.glass-drawer .drawer-footer {
  border-top: 1px solid rgba(255, 255, 255, 0.08) !important;
  background: rgba(8, 9, 12, 0.5) !important;
}

.gap-3 {
  gap: 12px;
}
</style>
